import type {
  ClientDetailsFill,
  ClientDetailsFillOutcome,
} from "@/features/forms/shared/record/client-details-fill";
import type { HandlerOutcome } from "@/features/intelligence/lib/frontend-tool-run";
import type { FillClientDetailsArgs } from "@/features/intelligence/lib/frontend-tools";

export function clientDetailsFillOf(args: FillClientDetailsArgs): ClientDetailsFill {
  const fill: ClientDetailsFill = {};
  if (args.personnummer) fill.identification = args.personnummer;
  if (args.address_line_1) fill.addressLine1 = args.address_line_1;
  if (args.address_line_2) fill.addressLine2 = args.address_line_2;
  if (args.zip_code) fill.zipCode = args.zip_code;
  if (args.city) fill.city = args.city;
  if (args.email) fill.email = args.email;
  if (args.phone) fill.phone = args.phone;
  return fill;
}

export function reportClientDetailsFill(outcome: ClientDetailsFillOutcome): HandlerOutcome {
  const held =
    outcome.held.length > 0
      ? ` Left as they are, because the client register already holds them: ${outcome.held.map((key) => NAMES[key]).join(", ")}.`
      : "";
  if (outcome.filled.length === 0) {
    return { ok: false, message: `Nothing was filled.${held}` };
  }
  return {
    ok: true,
    message:
      `Filled on the record's Kunduppgifter step: ${outcome.filled.map((key) => NAMES[key]).join(", ")}. ` +
      "Nothing is saved yet: the advisor checks the fields and saves them with Spara, which " +
      "creates them in the client register. Tell the advisor that, and do not say they were " +
      `saved or added.${held}`,
  };
}

export const NO_CLIENT_DETAILS: HandlerOutcome = {
  ok: false,
  message: "No record with a Kunduppgifter step is open. Nothing was filled.",
};

const NAMES: Record<keyof ClientDetailsFill, string> = {
  identification: "the identification number",
  addressLine1: "the street address",
  addressLine2: "the second address line",
  zipCode: "the postcode",
  city: "the city",
  email: "the email",
  phone: "the phone",
};
